import React from 'react';
import { NavLink } from 'react-router-dom';
import './Sidebar.css';

const Sidebar = () => {
  return (
    <aside className="sidebar" style={{ minWidth: '220px', maxWidth: '220px' }}>
{/* //       <div className="sidebar-header"> */}
{/*         <h4>Navigation</h4> */}
{/*       </div> */}
      <nav className="sidebar-content">
        <NavLink 
          to="/" 
          className={({ isActive }) => 
            `sidebar-link ${isActive ? 'active' : ''}`
          }
          end
        >
          <span className="link-icon">🏠</span>
          <span>Home</span>
        </NavLink>
        <NavLink 
          to="/extraction" 
          className={({ isActive }) => 
            `sidebar-link ${isActive ? 'active' : ''}`
          }
        >
          <span className="link-icon">🎬</span>
          <span>Shot Extraction</span>
        </NavLink>
        <NavLink 
          to="/merge" 
          className={({ isActive }) => 
            `sidebar-link ${isActive ? 'active' : ''}`
          }
        >
          <span className="link-icon">🔗</span>
          <span>Video Merge</span>
        </NavLink>

        <div className="sidebar-divider" />

        <div className="sidebar-header">
          <h4>Coming Soon</h4>
        </div>

        <NavLink 
          to="/coming-soon/split-videos" 
          className={({ isActive }) => 
            `sidebar-link ${isActive ? 'active' : ''}`
          }
        >
          <span className="link-icon">✂️</span>
          <span>Split Videos</span>
        </NavLink>

{/*         <NavLink  */}
{/*           to="/coming-soon/auto-merge"  */}
{/*           className={({ isActive }) =>  */}
{/*             `sidebar-link ${isActive ? 'active' : ''}` */}
{/*           } */}
{/*         > */}
{/*           <span className="link-icon">🧩</span> */}
{/*           <span>Auto Merge</span> */}
{/*         </NavLink> */}
      </nav>
    </aside>
  );
};

export default Sidebar;
